import ChevronRightButtonSvg from '@assets/images/svg/chevronright.svg';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface ChevronRightButtonIconProps {
    size?: number;
    color?: string;
}

export const ChevronRightButtonIcon: React.FC<ChevronRightButtonIconProps> = ({
    size = 32,
    color = '#333333',
}) => {
    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <ChevronRightButtonSvg width={size} height={size} color={color} />
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default ChevronRightButtonIcon;
